'use strict';

var defaultNewDate = require('../internal/defaultNewDate');

var DATE_OPTIONS = {
  'newDateInternal': defaultNewDate
};

module.exports = DATE_OPTIONS;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/var/DATE_OPTIONS.js
// module id = 602
// module chunks = 0